import {HttpEvent, HttpHandler, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {MsalInterceptor} from "@azure/msal-angular";
import {Observable} from "rxjs";
import {ImpersonationService} from "../services/impersonation.service";
import {inject, Injectable} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationInterceptor extends MsalInterceptor {
  private readonly impersonationService = inject(ImpersonationService);

  override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.impersonationService.hasImpersonationToken()) {
      const token = this.impersonationService.getImpersonationToken();

      req = req.clone({
        setHeaders: {
          Authorization: `UserImpersonation ${token}`
        }
      });

      return next.handle(req);
    }

    return super.intercept(req, next);
  }
}
